(function() {
  'use strict';
  if (window.__lamourCollectionPromotionGridInitialized) return;
  window.__lamourCollectionPromotionGridInitialized = true;

  function number(value, fallback) {
    var parsed = parseInt(value, 10);
    return Number.isFinite(parsed) ? parsed : fallback;
  }

  function layoutGrid(grid) {
    var products = Array.prototype.slice.call(grid.querySelectorAll(':scope > .grid-product'));
    var tiles = Array.prototype.slice.call(grid.querySelectorAll(':scope > [data-promotion-tile]'));
    if (!tiles.length) return;

    // Load more returns the same promotion blocks on every page.
    var uniqueTiles = [];
    var orders = {};
    tiles.forEach(function(tile) {
      var order = number(tile.dataset.promotionOrder, -1);
      if (orders[order]) {
        tile.remove();
      } else {
        orders[order] = true;
        uniqueTiles.push(tile);
      }
    });
    uniqueTiles.sort(function(a, b) {
      return number(a.dataset.promotionOrder, 0) - number(b.dataset.promotionOrder, 0);
    });

    var mobile = window.innerWidth <= 768;
    var columns = mobile ? 2 : Math.max(2, number(grid.dataset.promotionDesktopColumns, 4));
    var rows = Math.max(1, number(mobile ? grid.dataset.promotionMobileRows : grid.dataset.promotionDesktopRows, 2));
    var offset = Math.max(0, number(grid.dataset.promotionOffset, 0));
    var rowHeight = products.length ? Math.round(products[0].getBoundingClientRect().height) : 280;
    if (rowHeight > 0) grid.style.setProperty('--promotion-row-height', rowHeight + 'px');
    var layoutKey = [mobile, columns, rows, offset, products.length, uniqueTiles.map(function(tile) {
      return [tile.dataset.promotionOrder, tile.dataset.promotionDesktopColumns, tile.dataset.promotionMobileColumns].join(':');
    }).join(',')].join('|');
    if (grid._promotionLayoutKey === layoutKey) return;

    var globalSpans = 0;
    var previousOrder = -1;
    var previousPromotionRowEnd = 0;
    var visibleSpans = 0;
    var atProductCount = {};
    uniqueTiles.forEach(function(tile) {
      var order = Math.max(0, number(tile.dataset.promotionOrder, 0));
      var requestedSpan = number(mobile ? tile.dataset.promotionMobileColumns : tile.dataset.promotionDesktopColumns, 2);
      var span = Math.max(1, Math.min(columns, requestedSpan));
      var onRight = order % 2 === 1;

      // Count complete product-only rows after the preceding promotion row.
      // Products beside a narrow promotion finish that row, so they do not
      // count toward the next interval.
      var threshold = previousPromotionRowEnd + (order - previousOrder) * rows * columns;
      var globalColumn = (threshold + globalSpans) % columns;
      var targetColumn = onRight ? columns - span : 0;
      var globalAnchor = threshold + (targetColumn - globalColumn + columns) % columns;
      globalSpans += span;
      previousPromotionRowEnd = globalAnchor + (columns - (globalAnchor + globalSpans) % columns) % columns;
      previousOrder = order;

      // A direct paginated page starts a fresh grid. Loaded pages share one
      // grid, so only tiles present in this DOM contribute occupied columns.
      var localStart = Math.max(threshold, globalAnchor);
      var occupiedColumns = ((localStart - offset + visibleSpans) % columns + columns) % columns;
      var adjacentProducts = (targetColumn - occupiedColumns + columns) % columns;
      var anchor = localStart + adjacentProducts;
      tile.style.setProperty('--promotion-span', span);
      tile.hidden = globalAnchor <= offset || globalAnchor > offset + products.length || anchor > offset + products.length;
      tile.setAttribute('data-promotion-ready', '');
      if (!tile.hidden) {
        visibleSpans += span;
        (atProductCount[anchor] || (atProductCount[anchor] = [])).push(tile);
      }
    });

    // Product nodes retain their original order and event handlers when moved.
    var fragment = document.createDocumentFragment();
    products.forEach(function(product, index) {
      fragment.appendChild(product);
      var followingTiles = atProductCount[offset + index + 1] || [];
      followingTiles.forEach(function(tile) { fragment.appendChild(tile); });
    });
    uniqueTiles.forEach(function(tile) {
      if (tile.hidden) fragment.appendChild(tile);
    });
    grid.appendChild(fragment);
    grid._promotionLayoutKey = layoutKey;
  }

  function layoutAll() {
    document.querySelectorAll('.collection-content .collection-product-grid').forEach(layoutGrid);
  }

  var resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(layoutAll, 100);
  });
  document.addEventListener('collection:reloaded', layoutAll);
  document.addEventListener('collection:load-more', layoutAll);
  document.addEventListener('shopify:section:load', layoutAll);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', layoutAll);
  } else {
    layoutAll();
  }
})();
